import React from 'react';
import ComponentLibrary from './ComponentLibrary';
import ComponentForms from './forms';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import RichText, { noParagraphTags, voidTags } from './controls/RichText';
import { deepMap, hydrate } from './DataStructures';
import { summarizeItem, pathReduce, pathAssign, useForceUpdate } from './util';
const DEBUG = false;

// This form is responsible for adding new props to a component. Mostly unused.
export function NewKeyForm(props) {
  const [key, setKey] = React.useState("");
  const [type, setType] = React.useState("string");
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: e => {
      e.preventDefault();
      let val;
      if (type === "string") {
        val = "";
      } else if (type === "number") {
        val = 0;
      } else if (type === "boolean") {
        val = false;
      } else if (type === "object") {
        val = {};
      } else if (type === "array") {
        val = [];
      }
      props.onSubmit(key, type, val);
    }
  }, /*#__PURE__*/React.createElement(Form.Group, {
    onSubmit: e => {
      DEBUG && console.log("Form.Group onSubmit", e);
    }
  }, /*#__PURE__*/React.createElement(Form.Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Label, null, "New prop:")), /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: type,
    onChange: e => {
      setType(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", null, "string"), /*#__PURE__*/React.createElement("option", null, "number"), /*#__PURE__*/React.createElement("option", null, "boolean"), /*#__PURE__*/React.createElement("option", null, "object"), /*#__PURE__*/React.createElement("option", null, "array"))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    placeholder: "key",
    value: key,
    onChange: e => {
      setKey(e.target.value);
    }
  })))));
}
export function DataFormGroup({
  parent,
  index,
  options,
  triggerStateUpdate,
  openDataModal
}) {
  const key = index;
  let item = parent[key];
  let type = typeof item;
  DEBUG && console.log("Item type:", type, item, item ? item.type : item);
  let reorderButtons = [];
  let propButtons = [];
  if (typeof key === "number") {
    reorderButtons = [/*#__PURE__*/React.createElement(Button, {
      block: true,
      size: "sm",
      variant: "outline-dark",
      className: "editor-icon-button",
      title: "Move item up 1 slot",
      disabled: key <= 0,
      onClick: () => {
        let temp = parent[key - 1];
        parent[key - 1] = parent[key];
        parent[key] = temp;
        triggerStateUpdate();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-arrow-up"
    })), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      variant: "outline-success",
      className: "editor-icon-button",
      title: "Duplicate item",
      onClick: () => {
        let temp = deepMap(JSON.parse(JSON.stringify(parent[key])), hydrate);
        temp._ibuid = undefined;
        parent.splice(key, 0, temp);
        triggerStateUpdate();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-files"
    })), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      variant: "outline-danger",
      className: "editor-icon-button",
      title: "Delete item",
      disabled: item.type === "Component" && ComponentLibrary[item.tagName] === undefined || parent.type !== "Content" && parent.length === 1,
      onClick: () => {
        parent.splice(key, 1);
        triggerStateUpdate();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-x-lg"
    })), /*#__PURE__*/React.createElement(Button, {
      block: true,
      size: "sm",
      variant: "outline-dark",
      className: "editor-icon-button",
      title: "Move item down 1 slot",
      disabled: key >= parent.length - 1,
      onClick: () => {
        let temp = parent[key + 1];
        parent[key + 1] = parent[key];
        parent[key] = temp;
        triggerStateUpdate();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-arrow-down"
    }))];
  }
  if (typeof key !== "number" && !["tagName", "type", "children"].includes(key)) {
    propButtons = [/*#__PURE__*/React.createElement(Button, {
      size: "sm",
      variant: "outline-danger",
      className: "editor-icon-button ml-2",
      title: "Delete item",
      onClick: () => {
        delete parent[key];
        triggerStateUpdate();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-x-lg"
    }))];
  }
  // Types can be: string, number, bool, array, object, Content
  let control = "no data";
  if (type === "number") {
    control = /*#__PURE__*/React.createElement(Form.Control, {
      type: "number",
      value: item,
      onChange: e => {
        parent[key] = Number(e.target.value);
        triggerStateUpdate();
      }
    });
  } else if (type === "string") {
    control = /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      value: item,
      onChange: e => {
        parent[key] = e.target.value;
        triggerStateUpdate();
      }
    });
  } else if (type === "boolean") {
    control = /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      checked: item,
      onChange: e => {
        parent[key] = e.target.checked;
        triggerStateUpdate();
      }
    });
  } else if (type === "object") {
    let type = item.type;
    if (type === "Content" && parent.type !== "Component") {
      // TODO: revisit this exclusion for Component
      control = /*#__PURE__*/React.createElement(RichText, {
        value: item,
        inlineOnly: options === null || options === void 0 ? void 0 : options.inlineOnly,
        onChange: v => {
          parent[key] = v;
          triggerStateUpdate();
        }
      });
    } else {
      let summary = summarizeItem(item, 1, 30);
      control = /*#__PURE__*/React.createElement(Button, {
        block: true,
        variant: "secondary",
        onClick: () => {
          DEBUG && console.log("Pressed the", type, item.tagName, key, "button, opening", parent[key]);
          openDataModal(parent, key);
        }
      }, key, typeof key === "number" ? "." : ":", " ", type, " ", item.tagName, " ", /*#__PURE__*/React.createElement("small", null, summary));
    }
  } else {
    control = key + ":" + JSON.stringify(item);
  }
  return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, reorderButtons), /*#__PURE__*/React.createElement(Col, null, typeof key !== "number" && key !== "children" && /*#__PURE__*/React.createElement(Form.Label, null, key), propButtons, control)));
}

// This editor edits components in a generic way. Mostly unused.
export function PropEditor({
  item,
  triggerStateUpdate,
  openDataModal,
  exclude
}) {
  exclude = exclude || [];
  return /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: e => {
      e.preventDefault();
    }
  }, item.type === "Element" && /*#__PURE__*/React.createElement(DataFormGroup, {
    parent: item,
    index: "tagName",
    triggerStateUpdate: triggerStateUpdate,
    openDataModal: openDataModal
  }), item.props && Object.keys(item.props).filter(k => !exclude.includes(k)).map(k => /*#__PURE__*/React.createElement(DataFormGroup, {
    parent: item.props,
    index: k,
    triggerStateUpdate: triggerStateUpdate,
    openDataModal: openDataModal
  }))), /*#__PURE__*/React.createElement(NewKeyForm, {
    onSubmit: (key, type, val) => {
      item.props[key] = val;
      triggerStateUpdate();
    }
  })))));
}
export default function DataForm({
  data,
  path,
  disabled,
  scopedDataParent,
  openDataModal,
  scopeToItem,
  triggerStateUpdate,
  decrementActiveTab,
  refreshTabList,
  onChanged
}) {
  const [formValid, setFormValid] = React.useState();
  if (!path.map) {
    path = [path];
  }
  let parent = pathReduce(data, path.slice(0, -1));
  let item = pathReduce(data, path);
  if (item === undefined) {
    throw new Error(`DataForm: item undefined (${summarizeItem(parent, 2)} -> ${path.join(".")} => ${pathReduce(data, path)})`);
  }
  const debounceUpdate = React.useRef();
  const forceUpdate = useForceUpdate();
  let changed = () => {
    window.clearTimeout(debounceUpdate.current);
    debounceUpdate.current = window.setTimeout(() => {
      DEBUG && console.log("DataForm debounced!", this.compileIteration);
      if (onChanged) {
        onChanged();
      }
    }, 1000);
    forceUpdate();
  };
  let key = path[path.length - 1];
  if (item && (item.props || item.children)) {
    const ComponentForm = ComponentForms[item.tagName];
    if (ComponentForm) {
      return /*#__PURE__*/React.createElement("div", {
        className: disabled ? "ib-disabled" : undefined
      }, /*#__PURE__*/React.createElement(ComponentForm, {
        onChanged: changed,
        data: item,
        path: path,
        openDataModal: openDataModal,
        scopeToItem: scopeToItem,
        triggerStateUpdate: triggerStateUpdate,
        onChange: () => {
          triggerStateUpdate();
        },
        onValidityChange: setFormValid,
        decrementActiveTab: decrementActiveTab,
        refreshTabList: refreshTabList
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PropEditor, {
      item: item,
      triggerStateUpdate: triggerStateUpdate
    }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Form, {
      onSubmit: e => {
        e.preventDefault();
      }
    }, /*#__PURE__*/React.createElement(DataFormGroup, {
      parent: item,
      index: "children",
      options: item.children && !voidTags.includes(item === null || item === void 0 ? void 0 : item.tagName) && noParagraphTags.includes(item === null || item === void 0 ? void 0 : item.tagName) ? {
        inlineOnly: true
      } : undefined,
      triggerStateUpdate: triggerStateUpdate,
      openDataModal: openDataModal
    }), item !== scopedDataParent && !voidTags.includes(item === null || item === void 0 ? void 0 : item.tagName) && !noParagraphTags.includes(item === null || item === void 0 ? void 0 : item.tagName) && /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: () => this.scopeToItem(item)
    }, "Edit Children")));
  } else if (key === undefined) {
    return /*#__PURE__*/React.createElement(Form, {
      onSubmit: e => {
        e.preventDefault();
      }
    }, parent.map((v, k) => /*#__PURE__*/React.createElement(DataFormGroup, {
      key: k,
      parent: parent,
      index: k
    })));
  } else if (item.map) {
    return /*#__PURE__*/React.createElement(Form, {
      onSubmit: e => {
        e.preventDefault();
      }
    }, item.map((v, k) => /*#__PURE__*/React.createElement(DataFormGroup, {
      key: k,
      parent: item,
      index: k
    })), item.type === "Content" && /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: () => scopeToItem(item)
    }, "Edit Content"));
  } else if (typeof item === "object") {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
      onSubmit: e => {
        DEBUG && console.log("object form", e);
        e.preventDefault();
      }
    }, "object", Object.keys(item).map(k => /*#__PURE__*/React.createElement(DataFormGroup, {
      key: k,
      parent: item,
      index: k
    }))), /*#__PURE__*/React.createElement(NewKeyForm, {
      onSubmit: (key, type, val) => {
        item[key] = val;
        triggerStateUpdate();
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement(DataFormGroup, {
      parent: parent,
      index: key
    });
  }
}